import { useWatch } from 'react-hook-form';

import { FrequencyMode, SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { useCoreContext } from 'modules/frequencyManagement/contexts/CoreContext';
import { MODE } from 'modules/frequencyManagement/contexts/FormProvider';
import { NoCapSection } from './NoCapSection';
import { FixedCapSection } from './FixedCapSection';
import { Optimize } from '../optimize/Optimize';

export const CardBody = ({
  messageMedium,
  isEditingMedium,
  isOptimizeEnabled,
}: {
  messageMedium: SupportedMediums;
  isEditingMedium: boolean;
  isOptimizeEnabled: boolean;
}) => {
  const { getOptimizeDetailsMessageMedium } = useCoreContext();
  const mode = useWatch({ name: MODE });

  return (
    <div>
      {mode === FrequencyMode.Off && (
        <NoCapSection messageMedium={messageMedium} isEditing={isEditingMedium} />
      )}
      {mode === FrequencyMode.Cap && (
        <FixedCapSection messageMedium={messageMedium} isEditing={isEditingMedium} />
      )}
      {isOptimizeEnabled && mode === FrequencyMode.Optimize && (
        <Optimize
          isEditing={isEditingMedium}
          optimizeDetails={getOptimizeDetailsMessageMedium(messageMedium)}
        />
      )}
    </div>
  );
};
